import React, { useEffect, useState, useMemo, useCallback } from 'react';
// import intl from 'react-intl-universal';
import { replaceCDNDomain } from '../../utils'
import { setLanguageStore } from '../../utils/storage/language'
import { setPageScopeLanguage } from '../../utils/session/store'
import { addBehaviorsRecord } from '../../utils/BehaviorstatsHelp'
import { modifyUserInfoModel } from '../../model/store'
import { getMemberInfo } from '../../utils/storage/store'
import ukFlag from '../../assets/images/en_flag.png';
import cnFlag from '../../assets/images/cn_flag.png';
import thFlag from '../../assets/images/tha_flag.png';
import defImg from '../../assets/images/def_view.png'

import styles from './index.module.less'

// 将静态数据移到组件外部，避免重复创建
const FLAG_MAP = {
  en_US: ukFlag,
  zh_CN: cnFlag,
  th_TH: thFlag,
  ko_KR: require('../../assets/images/flag/ko_KR.png'),
  vi_VN: require('../../assets/images/flag/vi_VN.png'),
  de_DE: require('../../assets/images/flag/de_DE.png'),
  pt_BR: require('../../assets/images/flag/pt_PT.png'),
  nl_NL: require('../../assets/images/flag/nl_NL.png'),
  ja_JP: require('../../assets/images/flag/ja_JP.png'),
  bg_BG: require('../../assets/images/flag/bg_BG.png'),
  ar_SA: require('../../assets/images/flag/ar_SA.png'),
  fr_FR: require('../../assets/images/flag/fr_FR.png'),
  cs_CZ: require('../../assets/images/flag/cs_CZ.png'),
  fi_FI: require('../../assets/images/flag/fi_FI.png'),
  it_IT: require('../../assets/images/flag/it_IT.png'),
  hu_HU: require('../../assets/images/flag/hu_HU.png'),
  da_DK: require('../../assets/images/flag/da_DK.png'),
  ru_RU: require('../../assets/images/flag/ru_RU.png'),
  pl_PL: require('../../assets/images/flag/pl_PL.png'),
  hi_IN: require('../../assets/images/flag/hi_IN.png'),
  he_IL: require('../../assets/images/flag/he_IL.png'),
  sl_SI: require('../../assets/images/flag/sl_SI.png'),
  ms_MY: require('../../assets/images/flag/ms_MY.png'),
  my_MM: require('../../assets/images/flag/my_MM.png'),
}

const WELCOME_TEXT = {
  en_US: 'Welcome to the hotel',
  zh_CN: '欢迎来到酒店',
  th_TH: 'ยินดีต้อนรับสู่โรงแรม',
  ko_KR: '호텔에 오신 것을 환영합니다',
  vi_VN: 'Chào mừng bạn đến với khách sạn',
  de_DE: 'Willkommen im Hotel',
  pt_BR: 'Bem-vindo ao hotel',
  nl_NL: 'Welkom in het hotel',
  ja_JP: 'ホテルへようこそ',
  bg_BG: 'Добре дошли в хотела',
  ar_SA: 'مرحبا بكم في الفندق',
  fr_FR: 'Bienvenue dans l\'hôtel',
  cs_CZ: 'Vítejte v hotelu',
  fi_FI: 'Tervetuloa hotelliin',
  it_IT: 'Benvenuti all\'hotel',
  hu_HU: 'Üdvözöljük az otthonban',
  da_DK: 'Velkommen til hotellet',
  ru_RU: 'Добро пожаловать в отель',
  pl_PL: 'Witamy w hotelu',
  hi_IN: 'होटल में आपका स्वागत है',
  he_IL: 'ברוכים הבאים למלון',
  ms_MY: 'Selamat datang ke hotel',
  my_MM: 'ဟိုတယ်သို့ ကြိုဆိုပါသည်',
};

const ENTERTEXT = {
  en_US: 'Enter',
  zh_CN: '进入',
  th_TH: 'เข้า',
  ko_KR: '입력하다',
  vi_VN: 'đi vào',
  de_DE: 'betreten',
  pt_BR: 'entrar',
  nl_NL: 'binnenkomen',
  ja_JP: '入る',
  bg_BG: 'въведете',
  ar_SA: 'دخول',
  fr_FR: 'Entrer',
  cs_CZ: 'Vstoupit',
  fi_FI: 'Enter',
  it_IT: 'Entrare',
  hu_HU: 'Belepes',
  da_DK: 'Indtast',
  ru_RU: 'входить',
  pl_PL: 'Wejść',
  hi_IN: 'प्रवेश करें',
  he_IL: 'כניסה',
  ms_MY: 'Masuk',
  my_MM: 'ဝင်မည်',
}

// 工具函数移到组件外部
const getFlag = (code) => {
  const normalizedCode = code.replace('-', '_');
  return FLAG_MAP[normalizedCode] || defImg;
}

// 子组件：语言下拉选择器
const LanguageDropdown = React.memo(({
  selectedLanguage,
  languageList,
  isDropdownOpen,
  onToggle,
  onSelect
}) => (
  <div className={styles.dropdownWrapper}>
    <div className={styles.dropdown} onClick={onToggle}>
      <img src={selectedLanguage.flag} alt={selectedLanguage.name} className={styles.flag} />
      <span style={{ flex: 1 }}>{selectedLanguage.name}</span>
      <span className={styles.arrow}>▼</span>
    </div>

    {isDropdownOpen && (
      <div className={styles.dropdownList}>
        {languageList.map(language => (
          <div
            key={language.code}
            className={`${styles.dropdownItem} ${selectedLanguage.code === language.code ? styles.dropdownItemActive : ''
              }`}
            onClick={() => onSelect(language)}
          >
            <img src={language.flag} alt={language.name} className={styles.flag} />
            <span>{language.name}</span>
          </div>
        ))}
      </div>
    )}
  </div>
));

export default function LanguagePage({ onSelect, storeInfo }) {
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // 优化背景图片计算
  const backgroundImage = useMemo(() => {
    return storeInfo?.images?.split(',')[0];
  }, [storeInfo?.images]);

  // 优化语言列表处理
  const languageList = useMemo(() => {
    if (!storeInfo?.languages) return [];

    return Object.entries(storeInfo.languages).map(([code, name]) => {
      if (code.indexOf('-') > -1) {
        code = code.replace('-', '_')
      }
      return {
        code,
        name,
        flag: getFlag(code)
      }

    });
  }, [storeInfo?.languages]);

  // 优化欢迎文本
  const welcomeMessage = useMemo(() => {
    return WELCOME_TEXT[selectedLanguage?.code] || WELCOME_TEXT['en_US'];
  }, [selectedLanguage?.code]);

  const enterMessage = useMemo(() => {
    return ENTERTEXT[selectedLanguage?.code] || ENTERTEXT['en_US'];
  }, [selectedLanguage?.code])

  // 使用 useCallback 优化事件处理函数
  const handleToggleDropdown = useCallback(() => {
    setIsDropdownOpen(prev => !prev);
  }, []);

  const handleLanguageSelect = useCallback((language) => {
    setSelectedLanguage(language);
    setIsDropdownOpen(false);
    onSelect?.(language.code);

    //记录切换语言的行为统计
    addBehaviorsRecord({
      behaviorType: 160200,
      behavior: 160202,
      storeId: storeInfo.storeId,
      value1: language.code,
      value2: 'language_page'
    })
  }, [onSelect]);

  const handleConfirm = useCallback(() => {
    if (!selectedLanguage) return;

    try {
      onSelect?.(selectedLanguage.code);
      setLanguageStore(selectedLanguage.code);
      setPageScopeLanguage(selectedLanguage.code);

      modifyUserInfoModel({
        firstName: '',
        lastName: '',
        contactInfo: '',
        memberId: getMemberInfo().memberId,
        language: selectedLanguage.code
      }).then(res => {
        console.log(res)
      })

      window.location.reload();
    } catch (error) {
      console.error('Language selection failed:', error);
    }
  }, [selectedLanguage, onSelect]);

  // 初始化选中语言
  useEffect(() => {
    if (languageList.length > 0 && !selectedLanguage) {
      const defLan = languageList.find(item => item.code === 'en_US') || languageList[0]
      setSelectedLanguage(defLan);
    }
  }, [languageList, selectedLanguage]);

  // 早期返回优化
  if (!selectedLanguage) return null;

  const containerStyle = backgroundImage
    ? { backgroundImage: `url(${backgroundImage})` }
    : {};

  const { storeInfos } = storeInfo
  let obj = storeInfos.find(item => item.storeLanguage === selectedLanguage.code)
  if (!obj || (obj && !obj.homeWelcomeMessage)) {
    obj = storeInfos.find(item => item.storeLanguage === 'en_US')
  }

  const welcomeText = obj?.homeWelcomeMessage || welcomeMessage
  return (
    <div className={styles.container} style={containerStyle}>
      <div className={styles.logoBox}>
        <img src={replaceCDNDomain(storeInfo.logo)} alt="logo" className={styles.logo} />
      </div>
      <h2 className={styles.hotelName}>{storeInfo.name}</h2>

      <LanguageDropdown
        selectedLanguage={selectedLanguage}
        languageList={languageList}
        isDropdownOpen={isDropdownOpen}
        onToggle={handleToggleDropdown}
        onSelect={handleLanguageSelect}
      />

      <div className={styles.welcome}>
        {welcomeText}
      </div>

      <button className={styles.doneBtn} onClick={handleConfirm}>
        {enterMessage}
      </button>
    </div>
  );
}